import { c as _c } from "react/compiler-runtime";
import { useState, ViewTransition } from 'react';
import { useCacheKey } from '@libs/common-next';
import { CacheKey as Ck } from '@libs/vercel';
import css from './cache-key.module.scss';
import { config, type Id } from './config';
import { Contributors } from './contributors';
import { Details } from './details';
import { Status } from './status';
export function CacheKey() {
  const $ = _c(19);
  const ck = useCacheKey();
  const [value, setValue] = useState(ck.key);
  const [selected, setSelected] = useState("device");
  let t0;
  if ($[0] !== value) {
    t0 = config(Ck.decode(value));
    $[0] = value;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const sections = t0;
  let t1;
  if ($[2] !== ck.key) {
    t1 = () => setValue(ck.key);
    $[2] = ck.key;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1 || $[5] !== value) {
    t2 = <Status value={value} onRefresh={t1} />;
    $[4] = t1;
    $[5] = value;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== sections || $[8] !== selected) {
    t3 = <Contributors sections={sections} selected={selected} onSelect={setSelected} />;
    $[7] = sections;
    $[8] = selected;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const t4 = sections[selected];
  let t5;
  if ($[10] !== t4 || $[11] !== value) {
    t5 = <Details value={value} onChange={setValue} section={t4} onSelect={setSelected} />;
    $[10] = t4;
    $[11] = value;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t5) {
    t6 = <div className={css.grid}>{t3}{t5}</div>;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t2 || $[17] !== t6) {
    t7 = <ViewTransition name="container"><div className={css.wrapper}>{t2}{t6}</div></ViewTransition>;
    $[16] = t2;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}